import React from 'react';

import { SVGPropsType } from 'src/types';

function HeikinAshiChart(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M6.5999 5.89996H2.3999V14.3H6.5999V5.89996Z"
                stroke={stroke}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
            <path
                d="M4.5 2.59998V5.89998"
                stroke={stroke}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
            <path
                d="M13.5999 4.79999H9.3999V10.1H13.5999V4.79999Z"
                stroke={stroke}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
            <path
                d="M11.5 1.59998V5.39998"
                stroke={stroke}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
        </svg>
    );
}

export default HeikinAshiChart;
